
import Vue from 'vue';
import Component from "vue-class-component";
import {BoListPanel, BoPanel} from "bonomo";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {namespace} from "vuex-class";
import {ISettings} from "@/model/ISettings";
import LinkChip from "@/components/shared/chips/LinkChip.vue";
import {UrlHelper} from "@/helpers/UrlHelper";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import LockerChip from "@/components/shared/chips/LockerChip.vue";
import LandingPageCreationDialog from "@/components/settings/landingpages/LandingPageCreationDialog.vue";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
import {EPermissionActions} from "@/model/EPermissionActions";
import {Prop} from "vue-property-decorator";
import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
import LockerNav from "@/components/locker/widget/LockerNav.vue";

const settingsModule = namespace("settingsModule");
const lockerModule = namespace("lockerModule");

@Component({
  name: 'LandingPages',
  components:{
    BoListPanel,
    BoPanel,
    LinkChip,
    LandingPageCreationDialog,
    LockerChip,
    LockerNav,
    LockerSearch,
    SimpleConfirmationDialog,
  }
})

export default class LandingPages extends Vue {

  @Prop()
  protected lockerId!: number;

  @settingsModule.Getter('landingPages')
  private landingPages!: ISettings[];

  @lockerModule.Getter('lockers')
  private lockers!: ILocker[];

  @lockerModule.Action('fetchLockers')
  private fetchLockers!: () => void;

  @settingsModule.Action('fetchLandingPages')
  private fetchLandingPages!: (filters: {locker_id: number, search: string}) => void;

  @settingsModule.Action('clearLandingPages')
  private clearLandingPages!: () => Promise<any>;

  @settingsModule.Action('deleteLandingPage')
  private deleteLandingPage!: (id: number) => Promise<any>;

  protected search: string = '';

  private showCreateDialog:boolean = false;
  private showDeleteDialog:boolean = false;
  private landingPageToDelete:ISettings |null = null;

  loadData(){
    this.fetchLockers()
  }

  protected get extraFilters(): any {
    return {
      locker_id: this.lockerId,
      search: this.search,
    }
  }

  protected get headers(): BetterDataTableHeader[] {
    let ret: BetterDataTableHeader[] = [
      { text: 'id', align: 'start', sortable: true, value: 'id' },
      { text: 'slug', align: 'start', value: 'slug' },
      { text: 'tag', align: 'start', value: 'tag' },
      { text: 'smart point', align: 'start', value: 'smartPoint' },
      { text: 'link', align: 'start', value: 'link' },
    ];
    if (this.canDelete) {
      ret.push({ text: '', sortable: false, value: 'delete', align: 'center'});
    }
    return ret;
  }

  // I have to proxy as a) using locker_id as remote filter field would cause double loading when route is also changing,
  //  and b) not using locker_id as remote filter causes that it is not being sent to BE even if it is in extraFilters()
  protected fetchLandingPagesProxy() {
    return this.fetchLandingPages(this.extraFilters);
  }

  protected getLockerName(lockerId: number): string {
    for (let i = 0; i < this.lockers.length; i ++) {
      if(this.lockers[i].id == lockerId)
      {
        return this.lockers[i].name;
      }
    }
    return '---';
  }

  protected get canCreate(): boolean {
    return this.$canAction(EPermissionActions.ACTION_LANDINGPAGES_CREATE);
  }

  protected get canDelete(): boolean {
    return this.$canAction(EPermissionActions.ACTION_LANDINGPAGES_DELETE);
  }

  protected get oldPageUrl() {
    return UrlHelper.mayorLandingpages();
  }

  protected onLockerSelected(lockerId: number) {
    this.$router.push(lockerId
        ? {name: 'lockersLandingpages', params: {lockerId: '' + lockerId}}
        : {name: 'landingpages'}
    );
  }

  protected onDeleteLpBtn(landingPage: ISettings) {
    this.landingPageToDelete = landingPage;
    this.showDeleteDialog = true;
  }

  private onAcceptDeleteLpBtn() {
    if (this.landingPageToDelete) {
      this.deleteLandingPage(this.landingPageToDelete.id);
    }
    // this.closeDeleteDialog();
    this.showDeleteDialog = false;
  }


  private onOpenCreateDialog() {
    this.showCreateDialog = true;
  }

  private onCloseCreateDialog() {
    this.showCreateDialog = false;
  }

  protected gotoLockersLandingPages(lockerId: number) {
    this.onLockerSelected(lockerId);
  }

  protected gotoLocker(lockerId: number) {
    this.$router.push({name: 'locker', params: {lockerId: '' + lockerId}});
  }

}

